module.exports = __webpack_public_path__ + "static/media/member education icon (active).e640cd4e.svg";